import { date, number, object, string } from "yup";

export const getValidationSchema = (
  fieldName: string,
  doseMin?: number,
  doseMax?: number,
  isSuspension?: boolean
) => {
  const type = () => {
    const nullableNumber = number()
      .transform(value => (Number.isNaN(value) ? 0 : value))
      .nullable();

    const fieldType =
      fieldName === "route" ||
      fieldName === "labelInstructions" ||
      fieldName === "initials"
        ? string().nullable()
        : fieldName === "timeAdministered"
        ? date().nullable()
        : nullableNumber;

    const schema: { [key: string]: any } = {
      additionalVolumeDrawn: fieldType,
      additionalVolumeAdministered: fieldType,
      volumeAdministered: fieldType,
      timeAdministered: fieldType,
      labelInstructions: fieldType,
      numberOfTablets: fieldType,
      volumeToBeInfused: fieldType,
      tabletSize: fieldType,
      initials: fieldType,
      ...(isSuspension && { totalVolume: fieldType }),
      ...(doseMin &&
        doseMax && {
          doseMin: nullableNumber
            .required()
            .lessThan(doseMax, "Max dose value can't be lower than min dose."),
          doseMax: nullableNumber
            .required()
            .moreThan(doseMin, "Max dose value can't be lower than min dose.")
        })
    };

    return schema[fieldName] || fieldType.required();
  };

  return object({
    [fieldName]: type()
  });
};
